import React from "react";
import ReactApexChart from "react-apexcharts";

export default function SingleChart({ label, title, yTitle, seriesArray, forecastedValue = 0 }) {

  let options = {
    chart: {
      type: 'line',
      stacked: false,
    },
    stroke: {
      width: [0, 2, 5],
      curve: 'smooth'
    },
    title: {
      text: title
    },
    plotOptions: {
      bar: {
        columnWidth: '50%'
      }
    },
    fill: {
      opacity: [0.85, 0.25, 1],
      gradient: {
        inverseColors: false,
        shade: 'light',
        type: "vertical",
        opacityFrom: 0.85,
        opacityTo: 0.55,
        stops: [0, 100, 100, 100]
      }
    },
    labels: label,
    markers: {
      size: 0
    },
    yaxis: {
      title: {
        text: yTitle + ' in 1,000,000$',
      },
      labels: {
        formatter: function (val) {
          return (val / 1000000).toFixed(2);
        },
      }
    },
    tooltip: {
      shared: false,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== "undefined") {
            return y.toFixed(2) + "$";
          }
          return y;
        }
      }
    },
    legend: {       //this hides name of series
      show: false
    },
    dataLabels: {   //value shows on the chart
      enabled: false,
    },
    colors: [function({ value, seriesIndex, w }) {
      if(seriesIndex === 0) {
        if(value === forecastedValue ) return '#D9534F';
        else return '#239df9';
      }
      else return '#239df9';
    }]
  };
  
  let series = [{
    name: '',
    type: 'column',
    data: seriesArray
  }, {
    name: '',
    type: 'area',
    data: seriesArray
  }];

  return (
    <ReactApexChart options={options} series={series} type="line" width={800} />
  );
  
}